var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete2Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.868,
    height: 53.993,
    viewBox: "0 0 43.868 53.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_delete_4642891_000000",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M55.635,16.439a5.061,5.061,0,0,0-5.062-5.06H42.138a8.437,8.437,0,1,0-16.874,0H16.828a5.05,5.05,0,0,0-1.687,9.813V47.806a9.139,9.139,0,0,0,9.13,9.13H43.13a9.139,9.139,0,0,0,9.13-9.13V21.192a5.062,5.062,0,0,0,3.375-4.753ZM33.7,6.316a5.061,5.061,0,0,1,5.062,5.062H28.638A5.061,5.061,0,0,1,33.7,6.316ZM48.885,47.805a5.758,5.758,0,0,1-5.755,5.755H24.271a5.758,5.758,0,0,1-5.755-5.755V21.5h30.37Zm1.687-29.679H16.829a1.686,1.686,0,1,1,0-3.373H50.573a1.686,1.686,0,1,1,0,3.373Z",
    transform: "translate(-11.767 -2.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M48.746,66.052a1.687,1.687,0,0,0,1.687-1.687V45.8a1.687,1.687,0,1,0-3.375,0v18.56a1.687,1.687,0,0,0,1.687,1.687Z",
    transform: "translate(-26.812 -20.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M60.512,65.618A1.687,1.687,0,0,0,62.2,63.93V48.746a1.687,1.687,0,0,0-3.375,0V63.93a1.683,1.683,0,0,0,1.687,1.687Z",
    transform: "translate(-31.828 -21.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M36.98,65.618a1.683,1.683,0,0,0,1.687-1.687V48.746a1.687,1.687,0,0,0-3.375,0V63.93a1.687,1.687,0,0,0,1.687,1.687Z",
    transform: "translate(-21.796 -21.749)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2Img);
export default __webpack_public_path__ + "static/media/delete2_img.ff2216d1ff0be17c6f254cc11455329d.svg";
export { ForwardRef as ReactComponent };